import angular from 'angular';

module.exports = angular.module('common.filters.moment-to-date', [])
.filter('momentToDate', function() {
  return function(m) {
    return m.toDate();
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/moment-to-date.js
 **/